import React, { useRef, useEffect } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import Select from "components/ui/Select";
import useModalStore from "store/modals";
import { useAllPartySupMasts } from "http-hooks/partysupmast/usepartysupmast";

const SelectCustomers = ({
  value,
  onChange,
  placeholder = "Select Customer",
  isDisabled = false,
  isRequired = false,
  isMulti = false,
  label = "Customer",
  className = "",
  filters = {},
  showLabel = true,
  initialValue = null,
  showAddButton = true, // New prop to control plus button visibility
}) => {
  const hasInitialized = useRef(false);
  const { openModal } = useModalStore();
  
  const {
    isLoading: isLoadingAllCustAccount,
    data: { data: allCustAccounts } = [],
  } = useAllPartySupMasts({
    type: "C",
    level: 0,
    grplevel: 0,
    ag_status: 1,
    noPagination: true,
    ...filters,
  });

  // Handle initial value selection
  useEffect(() => {
    if (initialValue && !hasInitialized.current && allCustAccounts?.length > 0 && onChange) {
      try {
        if (!initialValue.ps_Id) {
          throw new Error('initialValue must contain ps_Id field');
        }
        
        const matchingOption = allCustAccounts.find(option => 
          option.ps_Id === initialValue.ps_Id
        );
        
        if (matchingOption) {
          onChange(matchingOption);
          hasInitialized.current = true;
        }
      } catch (error) {
        console.error('SelectCustomers initialValue error:', error);
        throw error;
      }
    }
  }, [initialValue, allCustAccounts, onChange]);

  const handleAddNew = () => {
    openModal('customer');
  };

  return (
    <div>
      {showLabel && (
        <div className="flex items-center justify-between mb-2">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {label} {isRequired && <span className="text-red-500">*</span>}
          </label>
          {showAddButton && !isDisabled && (
            <button
              type="button"
              onClick={handleAddNew}
              className="ml-2 p-1 text-xs font-bold bg-black text-white rounded hover:bg-gray-800 transition-colors duration-200 flex items-center"
              title="Add new customer"
            >
              <PlusIcon className="h-3 w-3" aria-hidden="true" />
            </button>
          )}
        </div>
      )}
      <Select
        value={value}
        onChange={onChange}
        options={allCustAccounts}
        getOptionValue={(option) => option?.ps_Id}
        getOptionLabel={(option) => option?.name}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isLoading={isLoadingAllCustAccount}
        isRequired={isRequired}
        isMulti={isMulti}
        label={label}
        className={className}
        showLabel={false}
        isClearable={true}
        isSearchable={true}
      />
      {!showLabel && showAddButton && !isDisabled && (
        <button
          type="button"
          onClick={handleAddNew}
          className="absolute top-0 right-0 h-10 w-10 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors duration-200"
          title="Add new customer"
        >
          <PlusIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default SelectCustomers; 